import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { PageContainer } from '../../../../common/components/styled-ui-elements';

interface ComplianceLoadingStateProps {
  message?: string;
}

/**
 * ComplianceLoadingState - Shared loading spinner displayed while compliance data is being fetched
 */
const ComplianceLoadingState: React.FC<ComplianceLoadingStateProps> = ({
  message = 'Loading...',
}) => {
  return (
    <PageContainer>
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <Box textAlign="center">
          <CircularProgress size={40} sx={{ color: '#3b82f6' }} />
          <Box mt={2} color="#64748b">
            {message}
          </Box>
        </Box>
      </Box>
    </PageContainer>
  );
};

export default ComplianceLoadingState;
